export default {"src":"/_next/static/media/section5-img.b94b537c.svg","height":400,"width":443,"blurWidth":0,"blurHeight":0};